import styled from 'styled-components';
import { font, spacing } from '@chegg-ui/theme';
export var Container = styled.div.withConfig({
  componentId: "sc-kxh27u-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;grid-gap:", ";margin-block-start:", ";margin-block-end:", ";"], spacing.px8, spacing.px32, spacing.px24);
export var ProviderIcon = styled.div.withConfig({
  componentId: "sc-kxh27u-1"
})(["display:flex;margin-bottom:", ";> svg{width:", ";height:", ";> path:first-child{fill:transparent;}}"], spacing.px4, font.size.px32, font.size.px32);
export var H3 = styled.h3.withConfig({
  componentId: "sc-kxh27u-2"
})(["font-size:", ";font-weight:normal;margin:0;max-width:250px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center;color:black;"], font.size.px18);
export var RemoveButton = styled.button.withConfig({
  componentId: "sc-kxh27u-3"
})(["display:flex;border:none;background:none;cursor:pointer;padding:0;"]);
export var RemoveIconWrapper = styled.div.withConfig({
  componentId: "sc-kxh27u-4"
})(["display:flex;> svg{width:", ";height:", ";}"], font.size.px20, font.size.px20);